import Reveal from '@/components/base/Reveal';
import { feedItems } from '@/mocks/home';
import SectionHeading from './SectionHeading';
import SidePanel from './SidePanel';

interface FeedSectionProps {
  notify: (msg: string) => void;
}

export default function FeedSection({ notify }: FeedSectionProps) {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-16">
        <Reveal>
          <SectionHeading
            kicker="实时速递"
            icon="ri-flashlight-line"
            title="今日热瓜速递 · 短讯并行"
            desc="把最新爆料、资源包动态与网盘修复提醒压成短讯卡片，滚动两屏就能掌握当天全部更新。"
            action={
              <button
                type="button"
                onClick={() => notify('已展开全部速递条目')}
                className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                查看全部
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-s-line"></i>
                </span>
              </button>
            }
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-xl border border-background-200 bg-background-50">
              {feedItems.map((item, index) => (
                <Reveal key={item.id} delay={index * 60}>
                  <button
                    type="button"
                    onClick={() => notify(`正在打开：${item.title}`)}
                    className="group flex w-full cursor-pointer items-start gap-4 p-4 text-left transition-colors hover:bg-background-100 md:p-5"
                  >
                    <span className="h-20 w-20 shrink-0 overflow-hidden rounded-lg bg-background-200 md:h-24 md:w-24">
                      <img
                        src={item.thumb}
                        alt={`${item.title} 相关素材内容合集配图`}
                        title={`${item.tag} - ${item.title}`}
                        className="h-full w-full object-cover object-top"
                      />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="flex flex-wrap items-center gap-2">
                        <span className={`rounded-sm px-2 py-0.5 text-[11px] font-medium ${item.tagClass}`}>{item.tag}</span>
                        <span className="text-xs text-foreground-400">{item.source}</span>
                      </span>
                      <span className="mt-2 block font-medium leading-snug text-foreground-950 md:text-[15px]">
                        {item.title}
                      </span>
                      <span className="mt-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                        <span className="flex items-center gap-1 whitespace-nowrap">
                          <span className="flex h-3.5 w-3.5 items-center justify-center">
                            <i className="ri-time-line"></i>
                          </span>
                          {item.time}
                        </span>
                        <span className="flex items-center gap-1 whitespace-nowrap">
                          <span className="flex h-3.5 w-3.5 items-center justify-center text-primary-500">
                            <i className="ri-fire-line"></i>
                          </span>
                          热度 {item.heat}
                        </span>
                      </span>
                    </span>
                    <span className="hidden shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs text-foreground-600 transition-colors group-hover:border-primary-300 sm:flex">
                      查看
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-arrow-right-s-line"></i>
                      </span>
                    </span>
                  </button>
                </Reveal>
              ))}
            </div>
          </div>

          <aside className="lg:col-span-4">
            <Reveal delay={120}>
              <SidePanel notify={notify} />
            </Reveal>
          </aside>
        </div>
      </div>
    </section>
  );
}